import { render, staticRenderFns } from "./form_add.vue?vue&type=template&id=39de6238&scoped=true"
import script from "./form_add.vue?vue&type=script&lang=js"
export * from "./form_add.vue?vue&type=script&lang=js"
import style0 from "./form_add.vue?vue&type=style&index=0&id=39de6238&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de6238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39de6238')) {
      api.createRecord('39de6238', component.options)
    } else {
      api.reload('39de6238', component.options)
    }
    module.hot.accept("./form_add.vue?vue&type=template&id=39de6238&scoped=true", function () {
      api.rerender('39de6238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/sign_group/form/components/form_add.vue"
export default component.exports